// extracted by mini-css-extract-plugin
module.exports = {"main-yellow":"#fcd406","searchbar":"Searchbar-module__searchbar___3yyA4","textInput":"Searchbar-module__textInput___4Y3ZK","searchBtn":"Searchbar-module__searchBtn___3wAGj"};